import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format a number as Nigerian Naira currency
 * @param amount - The amount in Naira
 */
export function formatNaira(amount: number): string {
  if (amount >= 1000000) {
    const millions = amount / 1000000;
    return `₦${millions.toFixed(1)}M`;
  }
  if (amount >= 1000) {
    const thousands = amount / 1000;
    return `₦${thousands.toFixed(0)}K`;
  }
  return `₦${amount.toLocaleString("en-NG")}`;
}
